import { Typography } from "@mui/material";

const formatINR = (value) => {
    const num = Number(value);
    if (isNaN(num)) return "₹0.00";
  
    return num.toLocaleString("en-IN", {
        style: "currency",
        currency: "INR",
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
};

export const AmountCell = ({ value }) => (
  <Typography sx={{ color: "#1976d2", fontWeight: 400 }}>
    {formatINR(value)}
  </Typography>
);